import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { object, string, func } from "prop-types";
import { SocialShare } from "@quintype/components";

import { Facebook } from "../../basic/icons/facebook";
import { Twitter } from "../../basic/icons/twitter";
import { Whatsapp } from "../../basic/icons/whatsapp";
import RightArrow from "../../basic/right-arrow";

import { loadNextStories } from "../../utils/api";

import "./next-story.m.css";

const socialShareIcons = ({ twitterUrl, fbUrl, whatsappUrl }) => {
  return (
    <ul>
      <li styleName="social-share-icon">
        <a styleName="social-share-link facebook-bg" href={fbUrl} target="_blank" rel="noopener noreferrer">
          <Facebook color="#fff" />
        </a>
      </li>
      <li styleName="social-share-icon">
        <a styleName="social-share-link twitter-bg" href={twitterUrl} target="_blank" rel="noopener noreferrer">
          <Twitter color="#fff" />
        </a>
      </li>
      <li styleName="social-share-icon">
        <a styleName="social-share-link whatsapp-bg" href={whatsappUrl} target="_blank" rel="noopener noreferrer">
          <Whatsapp color="#fff" />
        </a>
      </li>
    </ul>
  );
};

socialShareIcons.propTypes = {
  twitterUrl: string,
  fbUrl: string,
  whatsappUrl: string
};

const NextStoryStickey = ({ story, navigateToPage, lang }) => {
  const [nextStory, setNextStory] = useState([]);

  useEffect(() => {
    loadNextStories(1).then(items => {
      const storyId = localStorage.getItem("storyId");
      let findNextSory = items[0].id === story.id ? items[1] : items[0];
      if (storyId) {
        const oldIndex = items.findIndex(i => i.id === storyId);
        const nextStory = items[oldIndex + 1];
        findNextSory = nextStory && nextStory.id !== story.id ? nextStory : items[0];
      }
      setNextStory(findNextSory || items[0]);
    });
  }, []);

  const setStoryId = () => {
    if (nextStory.slug) {
      localStorage.setItem("storyId", nextStory.id);
      navigateToPage(`/${nextStory.slug}`);
    } else {
      console.log("next story not found");
    }
  };

  return (
    <div styleName="wrapper">
      <SocialShare template={socialShareIcons} title={story.headline} url={story.slug} color="#fff" />
      <div onClick={setStoryId} styleName={`next-button ${lang === "ur" ? "urdu-text" : ""}`}>
        <span styleName="text">next</span>
        <RightArrow />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], "en")
});

const mapDispatchToProps = dispatch => ({
  navigateToPage: url => global.app.navigateToPage(dispatch, url)
});

NextStoryStickey.propTypes = {
  story: object,
  navigateToPage: func,
  lang: string
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NextStoryStickey);
